/**
 * Copyright (C) Radiojar S.A. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 * Created by Tasos Kolokathis on 7/7/25.
 */

import store from "@/store";

class Panels {
	static onAir = {
		title: "OnAir",
		component: "OnAir",
		floating: {width: 900, height: 325},
		condition: ({liveMode, stationID}) =>
			liveMode ||
			!stationID ||
			store.getters.isFeatureEnabled({
				object_id: stationID,
				reference: "zettacloud_view_onair"
			}),
		feature: "zettacloud_view_onair"
	};
	static playlist = {
		title: "Playlist",
		component: "Playlist",
		floating: {width: 1000},
		condition: ({liveMode, stationID}) =>
			liveMode ||
			!stationID ||
			store.getters.isFeatureEnabled({
				object_id: stationID,
				reference: "zettacloud_view_playlist"
			}),
		feature: "zettacloud_view_playlist"
	};
	static library = {
		title: "Library",
		component: "Library",
		condition: ({liveMode, stationID}) =>
			liveMode ||
			!stationID ||
			store.getters.isFeatureEnabled({
				object_id: stationID,
				reference: "zettacloud_view_library"
			}),
		feature: "zettacloud_view_library"
	};
	static trafficLog = {
		title: "Traffic Log",
		component: "TrafficLog",
		condition: ({liveMode, stationID}) =>
			liveMode ||
			!stationID ||
			store.getters.isFeatureEnabled({
				object_id: stationID,
				reference: "zettacloud_view_traffic_log"
			}),
		feature: "zettacloud_view_traffic_log"
	};
	static stationLog = {title: "Station Log", component: "StationLog"};
	static hotkeys = {
		title: "Hot Keys",
		component: "HotKeys",
		condition: ({liveMode, stationID}) =>
			liveMode ||
			!stationID ||
			store.getters.isFeatureEnabled({
				object_id: stationID,
				reference: "zettacloud_view_hotkeys"
			}),
		feature: "zettacloud_view_hotkeys"
	};
	static calendar = {
		title: "Calendar",
		component: "Calendar",
		feature: "zettacloud_view_calendar"
	};
	static goLive = {
		title: "Go live",
		component: "GoLive",
		floating: {width: 800, height: 325},
		condition: ({liveMode}) => liveMode,
		feature: "zettacloud_view_go_live",
		disablePopout: true
	};
	static midi = {
		title: "MIDI UI",
		component: "MidiUI",
		floating: {width: 1170, height: 900},
		condition: ({liveMode, userIsHost}) => liveMode && userIsHost,
		feature: "zettacloud_view_midi"
	};

	static getArray({liveMode = false, userIsHost = false, stationID = null} = {}) {
		return Object.keys(this).reduce((panels, key) => {
			if (!this[key].condition || this[key].condition({liveMode, userIsHost, stationID})) {
				panels.push({
					title: this[key].title,
					value: key
				});
			}
			return panels;
		}, []);
	}
}

export default Panels;